import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton, ToggleButton, ToggleButtonGroup } from '@mui/material';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import YieldMatrixTable from '../Component/YieldMatrix/YieldMatrixTable';
import { utcToLocal } from '../Utils/timeConversions';
import { fetchMoodyRatingOptions } from '../http/api';
import { tokens, withAlpha } from '../Common/designTokens'; // added

const YieldMatrixPage = () => {
  const [lastUpdatedAt, setLastUpdatedAt] = useState(null);
  const [moodyRatings, setMoodyRatings] = useState([]);
  const [selectedYieldMetric, setSelectedYieldMetric] = useState('max'); // 'max' | 'median'

  useEffect(() => {
    // Fetch Moody's ratings on mount at page level
    const token = localStorage.getItem('token'); // or get from context if needed
    fetchMoodyRatingOptions(token)
      .then((data) => {
        if (Array.isArray(data)) setMoodyRatings(data);
      })
      .catch(() => setMoodyRatings([]));
  }, []);



  return (
    <>
      <Box
        sx={{
          color: tokens.colors.fontColour,
          padding: "16px 16px 0px 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <IconButton
            onClick={() => window.history.back()}
            sx={{ color: tokens.colors.fontColour85, mr: 1 }}
            aria-label="Go back"
          >
            <ArrowBackIcon />
          </IconButton>

          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
              <Typography
                variant="h6"
                component="div"
                sx={{
                  fontSize: { xs: "1rem", sm: "1.25rem" },
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Yield Table
              </Typography>

              <ToggleButtonGroup
                exclusive
                value={selectedYieldMetric}
                onChange={(_, val) => val && setSelectedYieldMetric(val)}
                size="small"
                sx={{
                  ml: { xs: 0, sm: 1 },
                  "& .MuiToggleButtonGroup-grouped": {
                    borderRadius: 0,
                    border: `1px solid ${tokens.colors.darkgray} !important`,
                    "&:not(:first-of-type)": {
                      borderLeft: `1px solid ${tokens.colors.darkgray} !important`,
                      marginLeft: 0,
                    },
                  },
                  "& .MuiToggleButton-root": {
                    textTransform: "none",
                    color: tokens.colors.fontColour,
                    px: 1.25,
                    height: 28,
                    backgroundColor: "transparent",
                    border: "none",
                    "&:hover": { backgroundColor: withAlpha(tokens.colors.white, 0.08) },
                  },
                  // selected button: color text and borders with primary
                  "& .MuiToggleButton-root.Mui-selected": {
                    color: tokens.palette.primary,
                    backgroundColor: `${withAlpha(tokens.palette.primary, 0.12)} !important`,
                    borderColor: `${tokens.palette.primary} !important`,
                    zIndex: 2,
                  },
                  "& .MuiToggleButton-root.Mui-selected:first-of-type": {
                    borderRightColor: "primary.main !important",
                  },
                  "& .MuiToggleButton-root.Mui-selected:last-of-type": {
                    borderLeftColor: "primary.main !important",
                  },
                  "& .MuiToggleButton-root.Mui-selected + .MuiToggleButton-root": {
                    borderLeftColor: `${tokens.palette.primary} !important`,
                  },
                }}
              >
                <ToggleButton value="max">Highest Yield</ToggleButton>
                <ToggleButton value="median">Median Yield</ToggleButton>
              </ToggleButtonGroup>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            minWidth: 180,
            textAlign: "right",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Typography sx={{ fontSize: "0.875rem", whiteSpace: "nowrap", color: tokens.colors.fontColour85 }}>
            Updated at: {utcToLocal(lastUpdatedAt)?.format("DMMMYY HH:mm") ?? "---"}
          </Typography>
        </Box>
      </Box>

      <YieldMatrixTable
        onLastUpdated={setLastUpdatedAt}
        moodyRatings={moodyRatings}
        yieldMetric={selectedYieldMetric}
      />
    </>
  );
};

export default YieldMatrixPage;